import { gql } from "@apollo/client";

export const deleteRemoteApiSpec = gql`
    mutation deleteRemoteApiSpec($specId: ID!) {
        deleteRemoteApiSpec(input: { id: $specId }) {
            id
        }
    }
`;
